/**
 * @file step
 * @author zhaomiaoyuan
 */
import React, {useEffect, useState, useCallback} from 'react';
import {withRouter} from 'react-router';
import PropTypes from 'prop-types';
import CallingCard from '../../components/CallingCard/index.tsx';
import {CONTACT_TIME_TYPE, HARASS_TYPE, TIP_LIST_MARK, TIP_LIST_HARASS} from './markType';
import {Checkbox, Button, message, DatePicker} from 'antd';
import InputFormItem from '../../components/InputFormItem/index.tsx';
import SelectFormItem from '../../components/SelectFormItem';
import RadioFormItem from '../../components/RadioFormItem/index.tsx';
import TextAreaFormItem from '../../components/TextAreaFormItem/index.tsx';

import SendCode from '../../components/SendCode/index.tsx';
import moment from 'moment';
import locale from 'antd/lib/locale/zh_CN';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');


import {recordProxy, bCat_2055_request, validateTellPhone, getQueryString} from '../../util';
import {
    ExclamationCircleOutlined
} from '@ant-design/icons';

const MarkStep2 = (props) => {
    const [protocolAgree, setProtocolAgree] = useState(false);
    const [isDescRequired, setIsDescRequired] = useState(false);

    const {
        updateMark,
        markData,
        fetchReportSubmit,
        fetchAttestSendCode,
    } = props;
    const {markType} = markData;
    const getDescRequiredStatus = () => {
        const phoneList = markData.phone.split('');
        const phoneLength = phoneList.length;
        const phoneLastNum = phoneList[phoneLength - 1];
        if (phoneLastNum % 2 === 0) {
            setIsDescRequired(true);
        }
    };
    useEffect(() => {
        getDescRequiredStatus();
    }, []);

    const handleMarkTag = (value) => {
        const data = value.data ? value.data : {};
        const tempArr = [];
        if (data.Tag) {
            Object.keys(data.Tag).map(item => {
                const tempObj = {
                    name: data.Tag[item],
                    tagId: item,
                    tagType: 'Tag'
                };
                tempArr.push(tempObj);
            });
        }
        if (data.Report) {
            Object.keys(data.Report).map(item => {
                const tempObj = {
                    name: data.Report[item],
                    tagId: item,
                    tagType: 'Report'
                };
                tempArr.push(tempObj);
            });
        }
        return tempArr;
    };
    const markTagList = handleMarkTag(markData.markTag);


    function verifyCheck(value, type) {
        if (!value) {
            updateMark({
                [type + 'Err']: '不能为空'
            });
            return false;
        }
        if (type === 'contactPhone' && validateTellPhone(value)) {
            updateMark({
                [type + 'Err']: '号码格式不正确'
            });
            return false;
        }

        if (type === 'callDate' && markData.callDateErr) {
            return false;
        }

        updateMark({
            [type + 'Err']: ''
        });
        return true;
    }

    const rewrite = useCallback(() => {
        recordProxy('rewrite', 'click', '');
        updateMark({
            curStep: 1,
            markTypeErr: '',
            phoneCodeErr: '',
            contactTimeErr: '',
            contactPhoneErr: '',
            callDateErr: '',
            descErr: '',
            harassTypeErr: ''
        });
    });
    const onMarkClick = useCallback((data) => {
        updateMark({
            markType: data,
            markTypeErr: ''
        });
    });

    function onSendCodeChange ({captchaTip}) {
        if (!markData.contactPhone) {
            return;
        }
        recordProxy(
            'report-captcha',
            'click',
            captchaTip === '获取验证码' ? '获取验证码' : '重新发送'
        );

    }

    const onSubmit = useCallback(async () => {
        const errPhone = verifyCheck(markData.contactPhone,'contactPhone');
        const errPhoneCode = verifyCheck(markData.phoneCode,'phoneCode');
        const errContactTime = verifyCheck(markData.contactTime,'contactTime');
        const errMarkType = verifyCheck(markData.markType,'markType');
        const errCallDate = verifyCheck(markData.callDate,'callDate');

        const errDesc = isDescRequired ? verifyCheck(markData.desc,'desc') : true;
        let errHarassType = true;
        if (markData.contactTime && markData.contactTime !== '未产生通话' && markType.tagType === 'Report') {
            errHarassType = verifyCheck(markData.harassType,'harassType');
        }
        if (!errPhone || !errPhoneCode || !errContactTime
            || !errMarkType || !errCallDate || !errHarassType || !errDesc
        ) {
            return;
        }
        const talkDuration = CONTACT_TIME_TYPE.findIndex(ele => ele.phone === markData.contactTime);
        const json = {
            phone: markData.phone.replace(/\s+/g, ''),
            mobile: markData.contactPhone,
            sms_code: markData.phoneCode,
            cat: markData.markType.tagType,
            tag_name: markData.markType.name,
            tag_id: markData.markType.tagId,
            talk_time: markData.callDate,
            talk_duration: talkDuration,
            talk_type: +markData.harassType,
            talk_desc: markData.desc,
        };
        const pagef = getQueryString('pagef') || '';
        const param = {
            pagef
        };
        recordProxy('report_submit', 'click', JSON.stringify(param));

        const fetchSubmit = (params) => fetchReportSubmit({
            ...json,
            ...params
        }).then(data => {
            if (data && data.code === 200) {
                recordProxy('report_submit_success', 'click', JSON.stringify(param));
                updateMark({
                    curStep: 3
                });
                window.scrollTo(0, 0);
            } else {
                message.error(data.message);
            }
        });
        bCat_2055_request(fetchSubmit);
    });
    const onPrevious = useCallback(() => {
        updateMark({
            curStep: 1
        });
    });
    const onProtocolCheck = useCallback((e) => {
        setProtocolAgree(e.target.checked);
    });

    const onOk = (value) => {
        let callDateErr = '';
        const todayTimestamp = new Date().getTime();

        const chooseTime = value.format('YYYY-MM-DD HH:mm');
        const chooseTimestamp = new Date(chooseTime).getTime();

        if (chooseTimestamp > todayTimestamp) {
            callDateErr = '来电日期不能超过当前时间';
        }

        updateMark({
            callDate: chooseTime,
            callDateErr: callDateErr
        });
    };
    const disabledDate = (current) => {
        return current && current > moment().endOf('day');
    };
    const renderTagTip = () => {
        if (markType.tagType === 'Tag'
            || markType.tagId === '1'
            || markType.tagId === '13'
            || markType.tagId === '6'
        ) {
            return '注：请保证填写内容真实有效。';
        }
        return '注：您举报的信息将提交给12321进行受理，请保证填写内容真实有效。';
    };
    return (
        <div className="mark-step2">
            <CallingCard
                data={{
                    phone: markData.phone,
                    phoneName: markData.phoneName
                }}
                rewrite={rewrite}
            />
            <p className="mark-title"><span>*</span>标记为</p>
            <div className="mark-part">
                {markTagList.map((val) => {
                    return (
                        <div
                            className="mark-part-item"
                            key={val.tagId}
                            onClick={() => onMarkClick(val)}
                        >
                            <div
                                className={
                                    markType.tagId === val.tagId
                                        ? 'mark-part-click-2'
                                        : 'mark-part-normal'
                                }
                            >
                                <p className="mark-title">{val.name}</p>
                            </div>
                        </div>
                    );
                })}
            </div>
            {markData.markTypeErr && <p className="error-tip" style={{marginTop: '-20px'}}>
                <ExclamationCircleOutlined style={{marginRight: '4px'}} />
                {markData.markTypeErr}
            </p>}
            <InputFormItem
                title={markType.tagType === 'Report' ? '被拨叫号码' : '您的手机号'}
                isMsgRequired={true}
                placeholder="用于校验核实"
                type="contactPhone"
                data={markData}
                updateData={updateMark}
                style={{width: '424px'}}
                demoImgs={[]}
            />
            <SendCode
                title="短信验证码"
                isMsgRequired={true}
                type="phoneCode"
                data={markData}
                updateData={updateMark}
                sendData={markData.contactPhone}
                fetchSendCode={fetchAttestSendCode}
                onSendCodeChange={onSendCodeChange}
            />
            <div className={'form-item-input'}>
                <p className="form-label star">请选择来电时间</p>
                <DatePicker
                    locale={locale}
                    showTime
                    showNow={false}
                    allowClear={false}
                    value={markData.callDate ? moment(markData.callDate, 'YYYY-MM-DD HH:mm') : ''}
                    format="YYYY-MM-DD HH:mm"
                    disabledDate={disabledDate}
                    onOk={onOk}
                />
            </div>
            {markData.callDateErr && <p className="error-tip" style={{marginTop: '8px'}}>
                <ExclamationCircleOutlined style={{marginRight: '4px'}} />
                {markData.callDateErr}
            </p>}
            <SelectFormItem
                title="通话时长"
                isMsgRequired
                placeholder="请选择"
                type="contactTime"
                isSingle={true}
                data={markData}
                phoneList={CONTACT_TIME_TYPE}
                onChange={value => updateMark({
                    contactTime: value,
                    contactTimeErr: ''
                })}
                style={{width: '424px'}}
            />
            {markData.contactTime
                && markData.contactTime !== '未产生通话'
                && markType.tagType === 'Report'
                && <div>
                    <RadioFormItem
                        title="通话类型"
                        isMsgRequired
                        type="harassType"
                        options={HARASS_TYPE}
                        data={markData}
                        onChange={e => {
                            updateMark({
                                harassType: e.target.value,
                                harassTypeErr: ''
                            });
                        }}
                    />
                </div>}
            <TextAreaFormItem
                title="来电描述"
                isMsgRequired={isDescRequired}
                placeholder={markType.tagType === 'Report'
                    ? TIP_LIST_HARASS
                    : TIP_LIST_MARK
                }
                type="desc"
                maxLength={200}
                data={markData}
                updateData={updateMark}
                style={{width: '424px'}}
            />
            <div className="mark-protocol">
                <p className="mark-tip">
                    {renderTagTip()}
                </p>
                <Checkbox onChange={onProtocolCheck}>
                    阅读并同意
                    <a
                        href="https://haoma.baidu.com/privacy/usernotice.html"
                        className={'link line'}
                        target={'_blank'}
                        rel="noopener noreferrer"
                    >
                        《百度号码标记用户须知》
                    </a>
                </Checkbox>
            </div>
            <div className="mark-btn-group">
                <Button className="mark-btn-next mark-btn" onClick={onPrevious}>上一步</Button>
                <Button
                    className="mark-btn-submit mark-btn"
                    type="primary"
                    onClick={onSubmit}
                    disabled={!protocolAgree}
                >提交</Button>
            </div>
        </div>
    );
};

MarkStep2.propTypes = {
    updateMark: PropTypes.func,
    markData: PropTypes.object,
    fetchCaptcha: PropTypes.func,
    fetchReportSubmit: PropTypes.func,
    fetchAttestSendCode: PropTypes.func
};

export default withRouter(MarkStep2);
